<app-base-modal
  [title]="'Добавить'"
>
  <form
    class="create-price-level-configs-form"
    [formGroup]="createPriceLevelConfigsForm"
  >
    @for (field of createPriceLevelConfigsFields; track $index) {
      @switch (field.type) {
        @case ('select') {
          <app-custom-mat-select
            [label]="field.label"
            [options]="getOptions(field.fieldName)"
            [needEmptyValue]="false"
            [isEditModeActive]="true"
            [fullWidth]="true"
            (selectedChange)="handleSelectChange($event, field.fieldName)"
          />
        }
        @case ('number') {
          <mat-form-field
            appearance="outline"
            class="create-price-level-configs-field"
          >
            <mat-label>
              {{ field.label }}
            </mat-label>
            <input
              matInput
              appDecimalLimit
              inputmode="decimal"
              [decimals]="0"
              [type]="field.type"
              [formControlName]="field.fieldName"
            >
          </mat-form-field>
        }
      }
    }
  </form>
  <div class="buttons-container">
    <button
      mat-button
      color="primary"
      class="save-button"
      [disabled]="createPriceLevelConfigsForm.invalid"
      (click)="handleCreate()"
    >
      Сохранить
    </button>
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Отменить
    </button>
  </div>
</app-base-modal>
